// $(window).on("scroll", function () {
//   if (window.scrollY > window.outerHeight) {
//     $("#scrollToTop").addClass("active");

//     var theta = ($(window).scrollTop() - (window.outerHeight + (window.outerHeight/2))) / 500;

//   } else {
//     $("#scrollToTop").removeClass("active");
//   }
// });

// $('#scrollToTop').on('click', function(e) {
//   e.preventDefault(); // Zapobiega domyślnemu działaniu linku
//   $("html, body").animate({ scrollTop: 0 }, 500);
// });

$(window).on("scroll", function() {
    if ($(this).scrollTop() > 0) {
        $('#scrollToTop').addClass('active');
    } else {
        $('#scrollToTop').removeClass('active');
    }
});

$('#scrollToTop').on('click', function(e) {
    e.preventDefault();
    $("html, body").animate({ scrollTop: 0 }, 500);
});
